const NewsletterSignup = (function(window, $) {

    function NewsletterSignup(target) {
        this.$element = $(target).not('.has-overview-page');
        this.$form = this.$element.find('form');
        this.$forminput = this.$element.find('form input');
        this.$success = this.$element.find('.newsletter-success');
        this.$error = this.$element.find('.newsletter-error');
        this.$newsletterPrivacyCheckbox = this.$element.find('.newsletter-privacy-checkbox');

        this.addEvents();
    }

    NewsletterSignup.prototype.addEvents = function() {
        this.$form.on('submit', this.submit.bind(this));
        this.$forminput.on('focusin', this.modifyState.bind(this));
        this.$newsletterPrivacyCheckbox.on('click', this.privacyCheckbox.bind(this));
    };

    NewsletterSignup.prototype.submit = function(e) {

        e.preventDefault();

        if($('.subscribe-toaster .btn').hasClass('disabled-newsletter-button')){
            $('.newsletter-optin-error-message').css({display: 'block'});
            return;
        }

        this.$success.hide();
        this.$error.hide();

        $.ajax(window.ajaxURL, {
            type: 'POST',
            data: this.$form.serialize()
        }).done(function (data) {
            this.$success.show();
            this.$form.fadeOut('fast');
        }.bind(this)).fail(function (data) {
            this.$error.show();
            let form = this.$form;

            form.fadeIn('fast');
            form.addClass('invalid');

            //Reset inputs
            form.find('.is-invalid').removeClass('is-invalid');
            form.find('.invalid-feedback').remove();

            $.each(data.responseJSON.data.errors, function(field_name, error) {
                form.find('[data-field='+field_name+']').first().addClass('is-invalid').append(
                    "<div class='invalid-feedback'>"+error+"</div>"
                );
            });
        }.bind(this));
    };

    NewsletterSignup.prototype.modifyState = function() {
        this.$form.removeClass('invalid');
        this.$error.hide();
        this.$form.find('.invalid-feedback').remove();
    }

    NewsletterSignup.prototype.privacyCheckbox = function(){
        if ($('.newsletter-privacy-checkbox').is(':checked')) {
            $('.subscribe-toaster .btn').removeClass('disabled-newsletter-button');
            $('.newsletter-optin-error-message').css({display: 'none'});
        } else {
            $('.subscribe-toaster .btn').addClass('disabled-newsletter-button', true);
        }
    }

    return NewsletterSignup;

}(window, jQuery));

export {NewsletterSignup};
